import File from '@/classes/facturae/File'
/** @import { File as _File } from 'node:buffer' */

/**
 * 
 * @param {_File} formFile 
 * @returns 
 */
async function convertFileToBase64 (formFile) {
  if (formFile.raw) {
    const file = new File()
    file.contenidoB64 = await new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onloadend = () => resolve(reader.result.split(',')[1]) // Extraemos solo el base64 (sin el encabezado 'data:...')
      reader.onerror = (error) => reject(error)
      reader.readAsDataURL(formFile.raw) // Leemos el archivo como un DataURL
    })
    file.Nombre = formFile.Nombre
    file.Mime = formFile.Extension
    return file
  }
  return null
}

export default convertFileToBase64
